var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container mass-import"},[_c('global-header'),_c('mass-import-body')],1)}
var staticRenderFns = []

export { render, staticRenderFns }